import React__default from 'react';

var FooterUserInfo = function (_a) {
    var isShowBalanceWin = _a.isShowBalanceWin, children = _a.children;
    return React__default.createElement("div", { className: "pgc-footer-user-info ".concat(isShowBalanceWin ? 'balance-win' : '') }, children);
};

export { FooterUserInfo };
